angular.module('zc.commonApi')

.factory "BaseProjectCrudService", (Api) ->
  class BaseProjectCrudService
    constructor: ($resource, @$q, @url, @obj_name, @obj_name_plural, transformers) ->
      options =
        get:
          method: 'GET'
        query:
          method: 'GET'
          isArray: false # Rails returns object instead of array
        create:
          method: 'POST'
          isArray: false # Rails returns object instead of array
        update:
          method: 'PATCH'
          isArray: false # Rails returns object instead of array

      if transformers
        options.get.transformResponse = transformers.response if transformers.response
        options.query.transformResponse = transformers.response if transformers.response
        options.create.transformRequest = transformers.request if transformers.request
        options.update.transformRequest = transformers.request if transformers.request

      @Resource = $resource Api.path(@url), { }, options

    all: (projectId, params) ->
      return @$q (resolve, reject) =>
        @Resource.query angular.extend({projectId}, params), (res) =>
          resolve res[@obj_name_plural]

    get: (projectId, id) ->
      return @$q (resolve, reject) =>
        @Resource.get {projectId: projectId, id: id}, (res) =>
          resolve res[@obj_name]

    create: (params, newObject) ->
      return @$q (resolve, reject) =>
        @Resource.create(params, newObject)
        .$promise.then (res) =>
          if res.success
            resolve res[@obj_name]
          else
            reject {}

    update: (params, newObject) ->
      return @$q (resolve, reject) =>
        @Resource.update(params, newObject)
        .$promise.then (res) =>
          if res.success
            resolve res[@obj_name]
          else
            reject {}

    delete: (projectId, id) ->
      return @$q (resolve, reject) =>
        @Resource.delete({projectId: projectId, id: id})
        .$promise.then (res) ->
          if res.success
            resolve id
          else
            reject {}



// WEBPACK FOOTER //
// ../app_shared/src/shared_modules/common_api/base_project_crud.service.js.coffee